import React from 'react';
//import Clients from '../components/Clients';
import Cta from '../components/Cta';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Cart from '../components/Cart';
import Intro from '../components/Intro';
// import Portfolio from '../components/Portfolio';
import Services from '../components/Services';
import Shopping from '../components/Shopping';
import { CartProvider } from "react-use-cart";


const Home = () => {
    


    return (
        <CartProvider>
            <Hero/>
            <Cart />
            <Intro />
            <Services />
            {/* <Portfolio /> */}
            {/* <Clients /> */}
            <Cta/>
            <Footer />
            <Shopping />
        </CartProvider>

    )
}

export default Home;

